import React, { 
    useState, 
    useEffect 
} from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import axios from 'axios';

import styles from './index.module.scss';
import CardAniversariante from './CardAniversariante';

// componente
export default function Aniversariantes({
    dataBase
}){

    // estados
    const history = useHistory();
    const [registros, alterarRegistros] = useState([]);    
    
    // consultar registros
    async function consultarRegistros(){

        try {

            const { data } = await axios.get(`/clientes/aniversariantes`, {
                params: {
                    data: dataBase
                }
            });
            alterarRegistros(data.datas);

        }catch({ response }){
            console.error(response);
        }

    }

    // inicializa
    useEffect(() => {
        consultarRegistros();
    }, [dataBase]);

    return (
        <div className={[styles.container, 'rounded p-2  h-100'].join(' ')}>
            <div className={[styles.aniversariantes, ' p-1 '].join(' ')}>
                {registros.map((registro, index) => 
                    <React.Fragment key={index}>
                        <p className={styles.data}>{moment(registro.data).format('DD/MM/YYYY')} <FontAwesomeIcon className={styles.icone} icon={["fas", 'calendar-day']} /></p>
                        {registro.registros.map(aniversario => 
                            <CardAniversariante 
                                key={aniversario.id}
                                dados={aniversario}
                                parabenizar={() => {
                                    history.push(`/painel/clientes/enviar-email-aniversariante/${aniversario.id}/${aniversario._idade_referencia}`);
                                }}
                                parabenizarSms={() => {
                                    history.push(`/painel/clientes/enviar-sms-aniversariante/${aniversario.id}/${aniversario._idade_referencia}`);
                                }}
                                parabenizarWhatsapp={() => {
                                    history.push(`/painel/clientes/enviar-whatsapp-aniversariante/${aniversario.id}/${aniversario._idade_referencia}`);
                                }}
                            />
                        )}
                    </React.Fragment>    
                )}
            </div>
        </div>
    )
}